<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 14,
                    wrapper: 10
                };
            }
        },
        user_hash: {
            type: String,
            default: ""
        },
        material: {
            type: String,
            default: ""
        },
        edit: {
            type: Boolean,
            default: false
        }
    },
    created() {
        if (this.editing) {
            this.preload = true;
            this.getItem();
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {}
        };
    },
    computed: {
        editing() {
            return this.edit
        }
    },
    methods: {
        getItem() {
            this.$http
                .get(
                    this.routeUri("api.classical.scores.objective_score", {
                        material: this.material,
                        user_hash: this.user_hash
                    })
                )
                .then(res => (this.item = res.data))
                .finally(() => (this.preload = false));
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;
                    
                    var scores = [];

                    for (var index = 0; index < this.item.objective_scores.length; ++index) {
                        scores.push(
                            {
                                objective: this.item.objective_scores[index].hash,
                                score: formData['param'+this.item.objective_scores[index].hash].toString()
                            }
                        )
                    }

                    var data = {
                        objectives: scores,
                        type: 'resume',
                        material_id: this.material,
                        user_hash: this.user_hash
                    }

                    let promise;

                    promise = this.$http.post(
                        this.routeUri("api.classical.scores.scoring"),
                        data
                    );

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 1000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
    },
    watch: {
        item: function(value) {

            for (var index = 0; index < value.objective_scores.length; ++index) {
                this.form.getFieldDecorator("param"+value.objective_scores[index].hash, {
                    initialValue: value.objective_scores[index].scores.length >= 1 ? value.objective_scores[index].scores[0].raw_score : 0
                });
            }
        }
    }
}
</script>

<template>
    <a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                <template v-for="v in item.objective_scores">
                        <a-form-item :label="v.objective"
                        :key="v.hash"
                    >
                        <a-input-number
                            :max="100"
                            :min="0"
                            v-decorator="[
                                'param'+v.hash,
                                {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Field ini wajib diisi'
                                        }
                                    ]
                                }
                            ]"
                        >
                        </a-input-number>
                    </a-form-item>
                </template>

                <a-form-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-card>
</template>
